import { render, staticRenderFns } from "./InstallationDocuments.vue?vue&type=template&id=540aaa90&scoped=true"
import script from "./InstallationDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallationDocuments.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstallationDocuments.vue?vue&type=style&index=0&id=540aaa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540aaa90",
  null
  
)

export default component.exports